import { render, staticRenderFns } from "./video-stream.vue?vue&type=template&id=edc88244"
import script from "./video-stream.vue?vue&type=script&lang=js"
export * from "./video-stream.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports